export default __webpack_public_path__ + "svg/CompaniesLogos/logo_nifty.svg?9d88d75e";